import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Breadcrumb } from "semantic-ui-react";
import Link from "~/components/element/Link";

@observer
class JobBreadcrumb extends Component {
  render() {
    const { viewJobsCallback, photoEditingJobId } = this.props;

    return (
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/" onClick={viewJobsCallback}>
            Jobs
          </Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active>{photoEditingJobId ? <>Job #{photoEditingJobId}</> : "New"}</Breadcrumb.Section>
      </Breadcrumb>
    );
  }
}

JobBreadcrumb.propTypes = {
  viewJobsCallback: PropTypes.func,
  photoEditingJobId: PropTypes.number,
};

export default JobBreadcrumb;
